export default __webpack_public_path__ + "static/media/review-legal.3d885dbc.md";